// affiliation types
export const DTC = 'dtc';
export const TWO_SEVENTY = '270';
export const CSV = 'csv';

// urls
export const REGISTER_ERROR_URL = '/register-error';
export const ELIGIBILITY_LOGIN_URL = '/eligible-login';
export const ELIGIBILITY_ERROR_URL = '/eligibility-error';
export const CREATE_ACCOUNT_URL = '/create-account';
// Pre-auth coverage-check flow: single-page account registration (reuses V2PatientForm). The
// coverage-check journey routes here instead of the two-step /create-account → /profile.
export const COVERAGE_REGISTER_URL = '/register-account';

// branding urls
export const BRANDING_ELIGIBLE_LOGIN_URL = '/register/eligible-login';
export const BRANDING_INSURANCE_URL = '/register/insurance';

export const INELIGIBLE_USER_ERROR = 'INELIGIBLE_USER_ERROR';
export const USER_REGISTERED_ERROR = 'USER_REGISTERED_ERROR';
export const DUPLICATE_USER_ERROR = 'DUPLICATE_USER_ERROR';
export const LOCKED_USER_ERROR = 'LOCKED_USER_ERROR';
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const MULTIPLE_AFFILIATION_ERROR = 'MULTIPLE_AFFILIATION_ERROR';
export const USER_ZIP_ERROR = 'USER_ZIP_ERROR';
export const ELIGIBILITY_CHECK_ZIP_ERROR = 'ELIGIBILITY_CHECK_ZIP_ERROR';
